import type { FieldError } from "react-hook-form";
import { cn } from "../../lib/utils";
import { YesNo } from "../../patterns/radio-select";
import { FormFieldError } from "../FormFieldError";

export type YesNoInputProps = {
	value?: boolean | null;
	onChange?: (value: boolean | null) => void;
	onBlur?: () => void;
	error?: FieldError;
	errorMessage?: string;
	disabled?: boolean;
	compact?: boolean;
	deselectable?: boolean;
	testId?: string;
};

export const YesNoInput = ({
	value,
	onChange,
	onBlur,
	error,
	errorMessage,
	disabled,
	compact,
	deselectable,
	testId,
}: YesNoInputProps) => {
	return (
		<div className="relative w-fit">
			<YesNo
				value={value ?? null}
				onChange={(newValue) => {
					if (disabled) return;
					onChange?.(newValue);
					onBlur?.();
				}}
				deselectable={deselectable}
				disabled={disabled}
				size={compact ? "compact" : "md"}
				className={cn(
					"rounded-md",
					error
						? "outline outline-danger hover:outline-danger-hover outline-offset-[6px]"
						: undefined,
				)}
				testId={testId}
			/>
			<FormFieldError
				error={error}
				errorMessage={errorMessage}
				className={cn("top-[-16px] left-[-8px]")}
			/>
		</div>
	);
};
